import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { get } from "lodash";
import CookieConsent from "react-cookie-consent";

import { Link, WithHostUrl } from "@quintype/components";

import { Icon } from "../../atoms/icon";

import styles from "./styles.m.css";

const MenuGroup = ({ menuGroup }) => {
  return (
    <div className={styles["menugroup-links-wrap"]}>
      {menuGroup.items.slice(0, 4).map(item => (
        <div key={item.id} className={styles["menugroup-links-column"]}>
          <h5 className={styles["heading"]}>
            {item.path ? (
              <a
                aria-label={`Read More about ${item.title}`}
                href={item.path}
                externalLink={item.isExternalLink ? item.path : null}
              >
                {item.title}
              </a>
            ) : (
              item.title
            )}
          </h5>
          <ul className={styles["menugroup-links"]}>
            {item.items &&
              item.items.map(menu => (
                <li key={menu.id} className={styles["menugroup-links-item"]}>
                  <a
                    aria-label={`Read More about" ${menu.title}`}
                    className={styles["menugroup-link"]}
                    href={menu.path || "#"}
                    externalLink={item.isExternalLink ? item.path : null}
                  >
                    {menu.title}
                  </a>
                </li>
              ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

const menuItemShape = {
  id: PropTypes.number.isRequired,
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

const MenuItem = PropTypes.shape(menuItemShape);

MenuItem.items = PropTypes.arrayOf(MenuItem);

MenuGroup.propTypes = {
  menuGroup: PropTypes.shape({
    items: PropTypes.arrayOf(MenuItem)
  })
};

const SocialLinks = ({ socialLinks }) => {
  const socialComponentIcons = {
    "facebook-url": <Icon type="facebook" />,
    "google-plus-url": <Icon type="gplus" />,
    "rss-url": <Icon type="rss" />,
    "twitter-url": <Icon type="twitter" />,
    "linkedin-url": <Icon type="linkedin" />,
    "youtube-url": <Icon type="youtube" />
  };
  return (
    <div className={styles["social-links-wrap"]}>
      <h5 className={styles["heading"]}>Connect</h5>
      <ul className={styles["social-icons"]}>
        {Object.keys(socialLinks).map(link => {
          return (
            socialLinks[link] &&
            socialComponentIcons[link] && (
              <li className={styles["social-link-item"]} key={link}>
                <a
                  aria-label={link}
                  key={link}
                  className={styles["social-link"]}
                  target="_blank"
                  rel="noopener  noreferrer"
                  href={socialLinks[link]}
                >
                  {socialComponentIcons[link]}
                </a>
              </li>
            )
          );
        })}
      </ul>
    </div>
  );
};

SocialLinks.propTypes = {
  socialLinks: PropTypes.shape({
    "facebook-url": PropTypes.string,
    "twitter-url": PropTypes.string,
    "linkedin-url": PropTypes.string,
    "youtube-url": PropTypes.string,
    "rss-url": PropTypes.string
  })
};

const AppStoreLinks = ({ appStoreLinks }) => {
  const AppStoreIcons = {
    "play-store": <Icon type="android-block" className={styles["android-css"]} />,
    "app-store": <Icon type="ios-block" className={styles["ios-css"]} />
  };
  return (
    <div className={styles["app-links-wrap"]}>
      <h5 className={styles["heading"]}>Download our app</h5>
      <ul className={styles["app-icons"]}>
        {Object.keys(appStoreLinks).map(link => {
          return (
            appStoreLinks[link] && (
              <li className={styles["app-link-item"]} key={link}>
                <a
                  aria-label={link}
                  href={appStoreLinks[link]}
                  target="_blank"
                  rel="noopener  noreferrer"
                  className={styles["app-link"]}
                >
                  {AppStoreIcons[link]}
                </a>
              </li>
            )
          );
        })}
      </ul>
    </div>
  );
};

AppStoreLinks.propTypes = {
  appStoreLinks: PropTypes.shape({
    "play-store": PropTypes.string,
    "app-store": PropTypes.string
  })
};

const Copyright = ({ copyright }) => {
  return (
    <div className={styles["copyright"]}>
      <div className={styles["copyright-text"]}>{copyright}. All Rights Reserved</div>
      <div className={styles["copyright-text"]}>
        Powered By{" "}
        <Link aria-label={"Open Quintype's Website"} href="https://www.quintype.com" target="_blank">
          <strong>Quintype</strong>
        </Link>
      </div>
    </div>
  );
};

Copyright.propTypes = {
  copyright: PropTypes.string
};

const Footer = ({ menuGroup = {}, socialLinks, appStoreLinks, copyright }) => {
  return (
    <footer className={styles["footer"]}>
      <CookieConsent
        contentClasses={styles["text-capitalize"]}
        buttonText="I Accept"
        cookieName="Cookie_Status"
        contentStyle={{ margin: "0 auto" }}
        expires={150}
        buttonClasses={styles["btn-acc"]}
        containerClasses={styles["dark"]}
        extraCookieOptions={{ domain: ".vikatan.com" }}
      >
        <p>
          விகடனின் பிரைவசி மற்றும் குக்கீ பாலிசிகளை ஏற்பதன் மூலம் உங்களுக்கு இத்தளத்தில் நிறைவான அனுபவம் கிடைப்பதை உறுதி
          செய்ய உதவுங்கள். நன்றி!
          <a href="https://www.vikatan.com/privacy-policy-web">
            <strong> பிரைவசி </strong>
          </a>
          <span>மற்றும்</span>
          <a href="https://www.vikatan.com/privacy-policy-web">
            <strong> குக்கீ பாலிசி</strong>
          </a>
        </p>
      </CookieConsent>
      <div className="container row">
        {menuGroup && menuGroup.items && <MenuGroup menuGroup={menuGroup} />}

        <div className={styles["social-app-copyright-wrap"]}>
          <WithHostUrl>
            {({ primaryHostUrl }) =>
              primaryHostUrl && socialLinks && !primaryHostUrl.match(/^https?:\/\/www.vikatan.tv/) ? (
                <SocialLinks socialLinks={socialLinks} />
              ) : null
            }
          </WithHostUrl>
          {appStoreLinks && <AppStoreLinks appStoreLinks={appStoreLinks} />}
          <Copyright copyright={copyright} />
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  menuGroup: PropTypes.shape(MenuGroup.propTypes),
  socialLinks: PropTypes.shape(SocialLinks.propTypes),
  appStoreLinks: PropTypes.shape(SocialLinks.propTypes),
  copyright: PropTypes.string
};

function mapStateToProps(state) {
  return get(state, ["qt", "data", "footer"]) || {};
}

export default connect(mapStateToProps)(Footer);
